var NCSK = NCSK || {};

NCSK.navigation = new function () {

    this.init = function () {
        shrinkMenu();
    }

    // Shrink menu on scroll
    function shrinkMenu() {
        var $window = $(window),
            menu = $('nav.navbar'),
            menuHeight = menu.innerHeight();

        $window.scroll(function () {
            menu.toggleClass('shrink', $window.scrollTop() > menuHeight + 100);
        });
    }
};

